module.exports = __webpack_public_path__ + "img/Réalisation récupérateur de pente ,pose en applique.d93ca775.jpg";